/* Notify Me — Clarity Labs (22 Sep 2026)
   Pairs with snippets/cl-notify-me.liquid. See the header there for the why.

   Rules this file never breaks:
   - The real Add to cart button is never enabled, removed, renamed or
     re-labelled. It is only hidden while a product is sold out.
   - Notify buttons are type="button", have no name, and no js-add-to-cart
     class, so neither GoKwik's observer nor sticky-atc.js ever sees them.
*/
(function () {
  'use strict';
  if (window.__clNotify) return;
  window.__clNotify = true;

  var CFG = window.clNotifyCfg || {};
  var QKEY = 'clNotifyQueue';
  var DONE = 'clNotifyDone';
  var BELL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>';

  /* ---------- storage (never trusted, always wrapped) ---------- */
  function readJSON(k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }
  function writeJSON(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function markDone(handle) { var d = readJSON(DONE, {}); d[handle] = Date.now(); writeJSON(DONE, d); }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- sending ---------- */
  function send(payload) {
    if (!CFG.hook) return Promise.reject(new Error('no hook'));
    var body = new URLSearchParams();
    Object.keys(payload).forEach(function (k) { body.append(k, payload[k] == null ? '' : String(payload[k])); });
    /* form-encoded + no-cors = a "simple" request: no preflight, works
       whatever CORS headers the webhook returns. The response is opaque,
       so only a network failure counts as a failure. */
    return fetch(CFG.hook, { method: 'POST', mode: 'no-cors', body: body, keepalive: true });
  }
  function queue(payload) { var q = readJSON(QKEY, []); q.push(payload); writeJSON(QKEY, q.slice(-20)); }
  function flushQueue() {
    var q = readJSON(QKEY, []);
    if (!q.length || !CFG.hook) return;
    writeJSON(QKEY, []);
    q.forEach(function (p) { send(p).catch(function () { queue(p); }); });
  }

  /* ---------- modal ---------- */
  var modal, current;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'cl-nm';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'cl-nm-title');
    modal.innerHTML = '<div class="cl-nm__scrim" data-nm-close></div><div class="cl-nm__panel"></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-nm-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }
  function panel() { return modal.querySelector('.cl-nm__panel'); }
  function prodRow(p) {
    return '<div class="cl-nm__prod">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') +
      '<div><b>' + esc(p.title) + '</b><span>Currently sold out</span></div></div>';
  }
  function close() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('cl-nm-open');
    if (current && current.opener) { try { current.opener.focus(); } catch (e) {} }
  }

  function open(p, opener) {
    if (!modal) buildModal();
    current = { p: p, opener: opener };
    var done = readJSON(DONE, {});
    if (done[p.handle]) return showDone(p, true);

    var c = CFG.customer || {};
    var phone = String(c.phone || '').replace(/\D/g, '').slice(-10);
    panel().innerHTML =
      '<button type="button" class="cl-nm__x" data-nm-close aria-label="Close">&times;</button>' +
      prodRow(p) +
      '<h3 id="cl-nm-title">Be first in line</h3>' +
      '<p class="cl-nm__sub">We’ll WhatsApp you the moment it’s back in stock.</p>' +
      '<form novalidate>' +
        '<label class="cl-nm__f"><em>+91</em><input name="phone" type="tel" inputmode="numeric" autocomplete="tel-national" maxlength="14" placeholder="WhatsApp number" value="' + esc(phone) + '" aria-label="WhatsApp number" required></label>' +
        '<label class="cl-nm__f"><input name="email" type="email" autocomplete="email" placeholder="Email address (optional)" value="' + esc(c.email || '') + '" aria-label="Email address"></label>' +
        '<input class="cl-nm__hp" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<p class="cl-nm__err" hidden></p>' +
        '<button type="submit" class="cl-nm__go">Notify me</button>' +
      '</form>' +
      (CFG.customer ? '' : '<p class="cl-nm__fine">Already have an account? <a href="' + esc(CFG.loginUrl || '/account/login') + '">Log in</a> to fill this in automatically.</p>') +
      '<p class="cl-nm__fine">By signing up you agree to get a restock message from Clarity Labs on WhatsApp and email.</p>';

    modal.hidden = false;
    document.documentElement.classList.add('cl-nm-open');
    var form = panel().querySelector('form');
    var first = form.querySelector(phone ? '[name=email]' : '[name=phone]');
    setTimeout(function () { try { first.focus(); } catch (e) {} }, 50);
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(form, p); });
  }

  function submit(form, p) {
    var err = form.querySelector('.cl-nm__err');
    var btn = form.querySelector('.cl-nm__go');
    if (form.company.value) { showDone(p); return; }            /* bot trap: pretend success */
    var digits = form.phone.value.replace(/\D/g, '');
    if (digits.length === 12 && digits.indexOf('91') === 0) digits = digits.slice(2);
    if (digits.length === 11 && digits.charAt(0) === '0') digits = digits.slice(1);
    var email = form.email.value.trim();
    var msg = '';
    if (!/^[6-9]\d{9}$/.test(digits)) msg = 'Please enter a valid 10-digit mobile number.';
    else if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) msg = 'That email doesn’t look right.';
    if (msg) { err.textContent = msg; err.hidden = false; return; }
    err.hidden = true;
    btn.disabled = true;

    var payload = {
      phone: '+91' + digits,
      email: email,
      product_handle: p.handle,
      product_title: p.title,
      product_id: p.id || '',
      variant_id: p.variant || '',
      tags: 'notify-me,notify-' + p.handle,
      customer_id: CFG.customer ? CFG.customer.id : '',
      source: p.source || '',
      page: location.href.split('#')[0],
      consent: 'Restock message on WhatsApp and email',
      ts: new Date().toISOString()
    };
    send(payload).catch(function () { queue(payload); }).then(function () {
      markDone(p.handle);
      showDone(p, false, digits);
    });
  }

  function showDone(p, already, digits) {
    var masked = digits ? '+91 ' + digits.slice(0, 2) + '••• ••' + digits.slice(-3) : '';
    panel().innerHTML =
      '<button type="button" class="cl-nm__x" data-nm-close aria-label="Close">&times;</button>' +
      '<div class="cl-nm__done"><div class="cl-nm__tick">&#10003;</div>' +
      '<h3 id="cl-nm-title">' + (already ? 'You’re already on the list' : 'You’re on the list') + '</h3>' +
      '<p class="cl-nm__sub">We’ll message you ' + (masked ? 'on ' + masked + ' ' : '') + 'as soon as ' + esc(p.title) + ' is back.</p>' +
      '<button type="button" class="cl-nm__go cl-nm__go--dark" data-nm-close>Keep shopping</button></div>';
    modal.hidden = false;
    document.documentElement.classList.add('cl-nm-open');
  }

  var LABEL = {
    /* every button says the product is sold out AND what tapping does */
    pdp: '<span class="cl-nm-so">Sold out</span><span class="cl-nm-dot">·</span><span class="cl-nm-cta">Notify me when it’s back</span>',
    satc: '<span class="cl-nm-so">Sold out</span><span class="cl-nm-dot">·</span><span class="cl-nm-cta">Notify me</span>',
    card: '<span class="cl-nm-so">Sold out</span><span class="cl-nm-dot">·</span><span class="cl-nm-cta">Notify me</span>'
  };
  function makeBtn(kind) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cl-nm-btn cl-nm-btn--' + kind;
    b.innerHTML = LABEL[kind];
    b.setAttribute('aria-label', 'Sold out. Get notified when this is back in stock.');
    return b;
  }

  /* ---------- product page: the Buy buttons block ---------- */
  function mountPdp() {
    var p = CFG.product;
    if (!p || p.available) return;
    p.source = 'pdp';
    var real = document.querySelector('main .main-product__buy-buttons--container button[name="add"]');
    if (real && !real.parentNode.querySelector('.cl-nm-btn--pdp')) {
      var b = makeBtn('pdp');
      /* borrow the real button's size classes so any height rule applies to both */
      b.className += ' ' + real.className.split(/\s+/).filter(function (c) {
        return /^wt-button/.test(c);
      }).join(' ');
      b.classList.remove('wt-button--secondary');
      real.insertAdjacentElement('afterend', b);
      b.addEventListener('click', function () { open(p, b); });
    }
    /* floating sticky bar — shown only via CSS when .satc.is-sold:not(.is-cart) */
    var addBt = document.querySelector('.satc [data-satc-add]');
    if (addBt && !addBt.parentNode.querySelector('.cl-nm-btn--satc')) {
      var s = makeBtn('satc');
      addBt.insertAdjacentElement('afterend', s);
      s.addEventListener('click', function () { var q = Object.assign({}, p, { source: 'sticky' }); open(q, s); });
    }
  }

  /* ---------- product cards ---------- */
  function handleFrom(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : ''; }
  /* Sold-out cards render a plain <div class="npg-atc"> with NO data attributes -
     the theme only puts data-variant-id on the buyable <npg-atc> element. So the
     product and variant ids simply are not in the card DOM. One small fetch of
     /products/<handle>.js fills them in, plus the canonical title. Fired on click,
     not on mount, so a grid of 40 cards costs nothing. If it fails, the signup
     still goes through with whatever the DOM gave us. */
  function enrich(p) {
    if (p.__enriched) return;
    p.__enriched = true;
    fetch('/products/' + encodeURIComponent(p.handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        p.id = d.id || p.id || '';
        p.title = d.title || p.title;
        if (d.variants && d.variants.length) p.variant = d.variants[0].id;
        if (d.featured_image) p.image = d.featured_image;
        /* refresh the modal header if it is still showing this product */
        if (modal && !modal.hidden && current && current.p === p) {
          var b = panel().querySelector('.cl-nm__prod b');
          if (b) b.textContent = p.title;
        }
      })
      .catch(function () {});
  }

  function mountCards(root) {
    var btns = (root || document).querySelectorAll('.npg-card div.npg-atc > .npg-atc__btn[disabled]');
    Array.prototype.forEach.call(btns, function (dead) {
      var wrap = dead.parentNode;
      if (wrap.classList.contains('cl-nm-swapped')) return;
      var card = wrap.closest('.npg-card');
      /* The title link MUST be looked up on its own. A comma selector returns the
         first match in DOCUMENT order, and the card's first anchor is
         a.npg-card__media, whose only text is the "Sold out" badge - that is how
         the title came through as "Sold out". */
      var titleLink = card && card.querySelector('.npg-card__title a');
      var anyLink = card && card.querySelector('a[href*="/products/"]');
      var link = titleLink || anyLink;
      var handle = link && handleFrom(link.getAttribute('href'));
      if (!handle) return;
      var titleEl = card.querySelector('.npg-card__title');
      var img = card.querySelector('.npg-card__img--main, img');
      var p = {
        handle: handle,
        title: ((titleEl || link).textContent || '').trim(),
        image: img ? (img.currentSrc || img.src) : '',
        source: 'card'
      };
      var b = makeBtn('card');
      wrap.appendChild(b);
      wrap.classList.add('cl-nm-swapped');
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        open(p, b);
        enrich(p);   /* fills id/variant/title in the background, before submit */
      });
    });
  }

  function init() {
    mountPdp();
    mountCards();
    flushQueue();
    /* grids re-render on filter/sort/pagination — pick up new cards */
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { mountCards(); }, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
